<template>
  <div class="viewing-result">
    <button
      class="viewing-result__go-back"
      @click="$emit('change', {}), (testData = '')"
    >
      <i class="el-icon-arrow-left"></i> Назад
    </button>
    <div ref="viewingContainer" class="viewing-result__container">
      <div class="top-section">
        <ul class="description__list">
          <li>
            <p>
              Студент: <span>{{ testData.student }}</span>
            </p>
          </li>
          <li>
            <p>
              Дисциплина: <span>{{ testData.discipline }}</span>
            </p>
          </li>
          <li>
            <p>
              Название теста: <span>{{ testData.testName }}</span>
            </p>
          </li>
          <li>
            <p>
              Тип теста: <span>{{ testData.testType }}</span>
            </p>
          </li>
          <li>
            <p>
              Дата прохождения теста: <span>{{ testData.date }}</span>
            </p>
          </li>
          <li>
            <p>
              Время, отведенное на тест (оставшееся):
              <span>{{ testData.testedTime }}</span>
            </p>
          </li>
          <li>
            <p>
              Всего вопросов: <span>{{ testData.allAnswers }}</span>
            </p>
          </li>
          <li>
            <p>
              Дано ответов: <span>{{ testData.correctAnswers }}</span>
            </p>
          </li>
        </ul>
        <div class="progress-list">
          <p>
            Итог: <span>{{ testData.grade }}</span>
          </p>
          <el-progress
            v-if="testData"
            :width="200"
            :stroke-width="10"
            type="circle"
            :percentage="
              Math.round(testData.correctAnswers / (testData.allAnswers / 100))
            "
          ></el-progress>
        </div>
      </div>
      <ul class="test-list">
        <li
          class="test-list__item"
          :style="{ backgroundColor: styleFunc(test) }"
          v-for="(test, index) of testData.bulletedAnswerList"
          :key="index"
        >
          <span class="test-item__test-name"
            >Вопрос №{{ test.answer_number }} ({{ test.source_number }})</span
          >
          <span class="test-item__question">{{ test.source.title }}</span>
          <ul class="test-item__answers-list">
            <li
              class="answers-list__item"
              v-for="(answer, answerIndex) in test.source.answers"
              :key="answerIndex"
            >
              <el-checkbox
                :value="setCheckbox(test, answerIndex)"
              ></el-checkbox>
              <span
                :class="['answer-item__text', { 'answer-right': answer.right }]"
                >{{ answer.html }}
                <i v-if="answer.right" class="fas fa-check"></i
              ></span>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      testData: "",
    };
  },
  props: {
    test: Object,
    group: Object,
  },
  methods: {
    setCheckbox(answer, index) {
      let status = false;
      answer.student_answers.forEach((el) => {
        if (Number(el) == index + 1) {
          status = true;
        }
      });
      return status;
    },
    scrollBottom() {
      let blockScroll = this.$refs.viewingContainer;
      console.dir(blockScroll);
      blockScroll.scrollTop = 0;
    },
    styleFunc(value) {
      return value.credited ? "#67C23A" : "#f56c6c";
    },
    percentFunction(b, a) {
      let percent = a / (b / 100);
      return a / percent;
    },
    fethHistories(value) {
      this.scrollBottom();
      this.axios(
        `api/tresults/${this.test.test_id}/group/${value.group_id}/histories/${value.hid}`
      ).then((res) => {
        this.testData = res.data;
      });
    },
  },
};
</script>

<style lang="scss">
.viewing-result {
  display: grid;
  grid-template-rows: max-content 1fr;
  border-radius: 30px;
  padding: 20px;
  background-color: $base-border-clr;
  transition: all 0.3s ease-in;
  width: 100%;
  position: absolute;
  height: 100%;
  backface-visibility: hidden;
}
.viewing-result__go-back {
  padding: 10px;
  justify-self: start;
  transition-duration: 0.3s;
  transition-property: color;
  font-size: 18px;
  color: $brand-clr-1;
  &:hover {
    color: lighten($color: $brand-clr-1, $amount: 10%);
  }
}
.progress-list {
  height: max-content;
  padding: 0 10px;
  display: grid;
  max-width: max-content;
  justify-items: center;
  p {
    color: $primary-text-clr;
    span {
      font-weight: bold;
    }
  }
}
.viewing-result__container {
  overflow-y: auto;
  width: 100%;
  height: 100%;
  padding-right: 5px;
}
.top-section {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.description__list {
  li {
    grid-template-columns: 1fr;
    width: 100%;
    list-style: none;
    p {
      color: $primary-text-clr;
      span {
        font-weight: bold;
        color: $basic-black;
      }
    }
  }
}
.test-list__item {
  max-width: 800px;
  display: grid;
  grid-template-rows: max-content max-content 1fr;
  row-gap: 10px;
  padding: 10px;
  border-radius: 10px;
  margin-bottom: 20px;
  background-color: $basic-white;
}
.test-item__answers-list {
  padding-left: 20px;
}
.answers-list__item {
  padding: 5px;
  display: grid;
  grid-template-columns: 10px 1fr;
  align-items: center;
  column-gap: 15px;
}
.test-item__test-name {
  color: $primary-text-clr;
  font-weight: bold;
}
.answer-item__text {
  width: max-content;
  color: $basic-white;
  padding: 5px;
  display: grid;
  column-gap: 20px;
  max-width: 100%;
  align-items: center;
  grid-template-columns: 1fr 20px;
  i {
    color: $success-clr;
  }
}
.answer-right {
  background-color: $basic-white;
  color: $regular-text-clr;
  border-radius: 5px;
}
.answer-item__text::first-letter {
  text-transform: uppercase;
}
@media (max-width: 800px) {
  .viewing-result {
    .viewing-result__container {
      overflow-y: scroll;
      height: 490px;
    }
    .top-section {
      flex-wrap: wrap;
    }
    .progress-list {
      margin: 0 auto;
    }
  }
}
</style>